/* eslint-disable */

import React from "react";
import { useNavigate } from "react-router-dom";

import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import OrganisationActivityElement from "../../../ui-components/organisation-activity-element/organisation-activity-element.tsx";
import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";
import RaindropInputTextArea from "../../../ui-components/raindrop-input-text-area/raindrop-input-text-area.tsx";
import { fetchGraphQL } from "../../../services/api-raindrop.js";
import RaindropInputFile from "../../../ui-components/raindrop-input-file/raindrop-input-file.tsx";

import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import Spacer from "../../../ui-components/spacer/spacer.js";
import { Size } from "../../../logic/enums.ts";

const CirrusActivityNew = ({ currentOrganisationUser }) => {
  const navigate = useNavigate();

  const [urlImageA, setUrlImageA] = React.useState<string | null>();
  const [urlImageB, setUrlImageB] = React.useState<string | null>();
  const [paragraphA, setParagraphA] = React.useState<string>("");
  const [activityText, setActivityText] = React.useState<string>(
    "We have helped 234 people in the last month"
  );
  const [activityUrl, setActivityUrl] = React.useState<string>("");

  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);

  const onSubmit = () => {
    setIsSubmitting(true);

    fetchGraphQL(`
      mutation {
        organisationActivityCreate(
          heading: "${activityText}"
          externalUrl: "${activityUrl}"
        ) {
          id
        }
      }
    `).then((response) => {
      if (response.data.organisationActivityCreate?.id) {
        navigate("/cirrus/activity");
      } else {
        console.error("Error creating activity", response);
      }
    });
  };

  return (
    <div className={`flex flex-row  gap-4 pb-4 `}>
      <RaindropCard additionalClasses="h-fit">
        <div className="flex flex-col gap-4 text-left text-color-text-primary  w-full h-fit">
          <div className="flex flex-col gap-2">
            <h1 className="font-bold text-4xl text-color-dark-text-primary">
              Create an Activity
            </h1>
            <div className="dark:text-color-dark-text-secondary text-color-text-secondary">
              Activites are a way to show your supports what you've been doing.
            </div>
          </div>

          <RaindropInput
            placeholder="What's happening?"
            value={activityText}
            onChange={(e) => setActivityText(e.target.value)}
            label="title"
            isShowLabel={true}
            icon=""
            maxLength={100}
          />

          <RaindropInputTextArea
            label={"Text"}
            value={paragraphA}
            onChange={(e) => setParagraphA(e.target.value)}
          />

          <RaindropInput
            label="external url"
            isShowLabel={true}
            icon=""
            onChange={(e) => setActivityUrl(e.target.value)}
            placeholder="https://example.com"
            value={activityUrl}
            maxLength={500}
          />

          <div className="flex flex-row gap-4 w-full items-center justify-center">
            <RaindropInputFile label="Image A" setImageUrl={setUrlImageA} />

            <RaindropInputFile label="Image B" setImageUrl={setUrlImageB} />
          </div>

          <div className="flex flex-row w-full">
            <Spacer />

            <RaindropButton
              title="Submit Activity"
              onClick={onSubmit}
              size={Size.Large}
              style={ButtonStyle.Primary}
              isLoading={isSubmitting}
            />
          </div>
        </div>
      </RaindropCard>

      <div
        className={`hidden lg:flex flex-col w-full h-full items-center p-4 pb-20 gap-20 overflow-y-auto overflow-x-hidden dark  rounded-lg  border-color-dark-border-tertiary 
      bg-color-dark-background-primary max-w-lg`}
      >
        <OrganisationActivityElement
          organisationName={currentOrganisationUser.organisation.name}
          text={activityText}
          organisationPresignedUrl={
            currentOrganisationUser.organisation.presigned_url_logo
          }
        />
      </div>
    </div>
  );
};

export default CirrusActivityNew;
